/**
 * @link https://stackoverflow.com/a/46455994/1847705
 */
import { Pipe, PipeTransform } from '@angular/core';

@Pipe( { name: 'bankAccount' } )
export class BankAccountPipe implements PipeTransform {
    
    transform( pBankAccount: any ): string {
        if ( pBankAccount != null ) {
            return pBankAccount[ 'BankName' ] + (pBankAccount[ 'BranchName' ] ? ' - ' + pBankAccount[ 'BranchName' ] : '') + ' (' + pBankAccount[ 'AccountNo' ] + ')';
        }
        return '';
    }
}
